// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__3OY_Q","logo":"Menu_logo__2HKRa","lightTheme":"Menu_lightTheme__10VN-","darkTheme":"Menu_darkTheme__3AoZ2","storeLink":"Menu_storeLink__1Yl9A"};